import TemplateView from "../../../TemplateView"
import {MODE} from "../UserPanelContainer"
import EditPanelUserRatesTable from './userRates/EditPanelUserRatesTable'
import CreatePanelUserRatesTable from './userRates/CreatePanelUserRatesTable'
import LoadingContainer from '../../../util/LoadingContainer'

export default class UserRates extends TemplateView {
    constructor({
        id,
        mode,
        scrollTo = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()
        this.id = id;
        this.updateOnInit = false;
        this.mode = mode
        this.scrollTo = scrollTo

        this.callbacks = {
            refreshScrollCb,
            subscribeSelectorOnScroll,
        }

        this.state = {
            userManagementData: null,
            currentTime: null,
            rates: [],
            overtimeLevel: null,
            isURAEnabled: false,
            updating: false,
        }

        this.onStateChanged((state) => {
            this.state.rates = state.rates
            this.state.overtimeLevel = state.overtimeLevel
            this.update()
        })

        this.onStatePropertyChanged('updating', loading => this.loadingWrapper.setState({loading}))
    }

    templateHtml() {
        return "<div class='userRates'>" +
               "    <div class='sectionHeader'><%=cost_of_work_rates%></div>" +
               "    <div class='userRatesSection'>" +
               "    </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            cost_of_work_rates: 'userlist.userdata.schedule.cost_of_work_rates'
        }
    }

    afterRender() {
        this.userRatesTable = this.mode === MODE.EDIT
          ? new EditPanelUserRatesTable({
                readOnly: false,
                scrollTo: this.scrollTo,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll
            })
          : new CreatePanelUserRatesTable({
                readOnly: false,
                scrollTo: this.scrollTo,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            })

        this.loadingWrapper = new LoadingContainer({
            contentComponent: this.userRatesTable,
            proxySetState: false,
            loadingMoireConfig: {
                delay: 500
            },
        }).init(this.find('.userRatesSection'))

        this.registerChildComponents(this.userRatesTable)
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/UserRates.js